<template>
  <figure
    class="bp-schematic"
    data-bp-draw
    data-bp-hover
    aria-labelledby="schematic-caption"
  >
    <figcaption
      id="schematic-caption"
      class="bp-schematic__cap"
    >
      <span class="bp-label">Fig. 1 &nbsp;Career signal path</span>
      <span
        class="bp-label"
        aria-hidden="true"
      >Not to scale</span>
    </figcaption>

    <ol class="bp-path">
      <li class="bp-node">
        <span class="bp-balloon">1</span>
        <span class="bp-node__org">Logitech<br>LifeSize Communi&shy;cations</span>
        <span class="bp-node__role">IT positions</span>
        <span class="bp-node__state bp-label">Earlier</span>
        <span
          class="bp-wire"
          data-bp-i="0"
          style="--bp-i: 0"
          aria-hidden="true"
        />
      </li>
      <li class="bp-node">
        <span class="bp-balloon">2</span>
        <span class="bp-node__org">Aspyr Media</span>
        <span class="bp-node__role">Director of IT</span>
        <span class="bp-node__state bp-label">Previous</span>
        <span
          class="bp-wire"
          data-bp-i="1"
          style="--bp-i: 1"
          aria-hidden="true"
        />
      </li>
      <li class="bp-node">
        <span class="bp-balloon">3</span>
        <span class="bp-node__org">Liatrio</span>
        <span class="bp-node__role">Principal DevOps Engineer</span>
        <span class="bp-node__state bp-node__state--live bp-label">Current</span>
        <span
          class="bp-wire"
          data-bp-i="2"
          style="--bp-i: 2"
          aria-hidden="true"
        />
      </li>
      <li>
        <NuxtLink
          to="/#contact"
          class="bp-node bp-node--next"
        >
          <span class="bp-balloon">4</span>
          <span class="bp-node__org">Your team</span>
          <span class="bp-node__role">Next connection. Write to Daniel</span>
          <span class="bp-node__state bp-label">Open</span>
          <span
            class="bp-wire bp-wire--out"
            data-bp-i="3"
            style="--bp-i: 3"
            aria-hidden="true"
          />
        </NuxtLink>
      </li>
    </ol>

    <div class="bp-rail">
      <span class="bp-rail__label bp-label">Running in parallel</span>
      <ul>
        <li>
          <span class="bp-balloon">5</span>
          <span>
            <span class="bp-label">Open source</span>
            <span class="bp-rail__text">Contributes to over 20 libraries, toolsets and system images</span>
          </span>
        </li>
        <li>
          <span class="bp-balloon">6</span>
          <span>
            <span class="bp-label">Speaking</span>
            <span class="bp-rail__text">AWS Summits, ServerlessConf, DevOpsDays, ChefConf and more</span>
          </span>
        </li>
        <li>
          <span class="bp-balloon">7</span>
          <span>
            <span class="bp-label">Community</span>
            <span class="bp-rail__text">Austin meetups; training junior- and mid-level talent</span>
          </span>
        </li>
      </ul>
    </div>
  </figure>
</template>
